import { Form, Formik } from 'formik';
import { type ModalStatusType } from '../../../../types/common';
import ModalComponent from '../../../../components/modal/modal';
import ModalBodyComponent from '../../../../components/modal/modalBodyComponent';
import ModalFooterComponent from '../../../../components/modal/modalFooterComponent';
import InputText from '../../../../components/input-text/inputText';
import _ from 'lodash';
import CustomDatePicker from '../../../../components/date-picker/customDatePicker';
import { TAX_PERIOD_VALIDATION } from '../../../../utils/validations/validations';
import usePostTaxPeriod from '../../../../hooks/post/usePostTaxPeriod';
import useWealthlaneTaxApi from '../../../../hooks/useWealthlaneTaxApi';

interface TaxYearType {
  isModalOpen: boolean;
  closeModal: () => void;
  modalStatus: ModalStatusType;
  setModalStatus: (value: ModalStatusType) => void;
  loading?: boolean;
  initialValue: any;
  setInitialValue: any;
  id?: string;
}

const TaxYearModal = ({
  isModalOpen,
  closeModal,
  modalStatus,
  setModalStatus,
  loading,
  initialValue,
  setInitialValue,
  id,
}: TaxYearType): JSX.Element => {
  const { handleRequest } = useWealthlaneTaxApi();
  const { mutate, isLoading } = usePostTaxPeriod(handleRequest, closeModal, initialValue?.id);
  const handleSubmit = (values: any): void => {
    mutate(values);
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValue}
      validationSchema={TAX_PERIOD_VALIDATION}
      onSubmit={(values) => {
        handleSubmit(values);
      }}>
      {({ touched, handleChange, errors, setFieldValue, setFieldTouched, values }) => {
        return (
          <ModalComponent
            show={isModalOpen}
            closeModal={closeModal}
            loading={loading}
            valueEdited={_.isEqual(values, initialValue)}
            size='sm'
            // title={`Edit Federal Tax`}
            title={`${modalStatus === 'Add' ? 'Create' : modalStatus} Tax Period`}
            id={id}
            children={
              <Form id="taxYearForm">
                <ModalBodyComponent id="taxYearModalBody">
                  <div className='' id="taxYearFormContainer">
                    <div className='' id="taxPeriodNameContainer">
                      <InputText
                        type='text'
                        label='Tax Period Name'
                        name='name'
                        id='name'
                        onChange={handleChange}
                        errors={errors}
                        touched={touched}
                        inputType={modalStatus}
                        disabled={modalStatus === 'View'}
                        required
                      />
                    </div>
                    <div className='grid md:grid-cols-2 sm:grid-cols-1 gap-x-8' id="taxPeriodDateRangeContainer">
                      <CustomDatePicker
                        label='Start Date'
                        arrValue={values?.effectiveFrom}
                        name={`effectiveFrom`}
                        id='effectiveFrom'
                        onChange={handleChange}
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                        errors={errors}
                        touched={touched}
                        // values={values}
                        errorValue={errors?.effectiveFrom}
                        touchedValue={touched?.effectiveFrom}
                        // min={new Date()}
                        defaultValue={new Date()}
                        disabled={modalStatus === 'View'}
                        fieldLabelName='test'
                        required
                      />
                      <CustomDatePicker
                        label='End Date'
                        name='effectiveTill'
                        id='effectiveTill'
                        onChange={handleChange}
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                        errors={errors}
                        touched={touched}
                        errorValue={errors?.effectiveTill}
                        touchedValue={touched?.effectiveTill}
                        arrValue={values?.effectiveTill}
                        // values={values}
                        min={values?.effectiveFrom}
                        defaultValue={new Date()}
                        disabled={!!(modalStatus.length > 0 && modalStatus === 'View')}
                        fieldLabelName='test'
                        required
                      />
                    </div>
                  </div>
                </ModalBodyComponent>
                <ModalFooterComponent
                  modalStatus={modalStatus}
                  loading={isLoading}
                  id="taxYearModalFooter"
                  // titleCollection={{ reviewTitle: 'Review & Confirm', cancelTitle: 'Go Back' }}
                  onCloseModal={() => {
                    setInitialValue('');
                    closeModal();
                  }}
                  valueChanged={_.isEqual(values, initialValue)}
                  onEditModal={() => {
                    setModalStatus('Edit');
                  }}
                />
              </Form>
            }
          />
        );
      }}
    </Formik>
  );
};

export default TaxYearModal;
